import { AlertTriangle } from "lucide-react";
import { ChecklistStrip } from "../GuideCards";

const studentProblems = [
    "Don’t know how to respond when they witness bullying",
    "Stay silent out of fear of social consequences",
    "Lack safe spaces to process what they experience",
    "Feel disconnected from peers and unsupported emotionally",
];

export default function SchoolsProblem() {
    return (
        <section className="relative overflow-hidden bg-[#f8f4ea] px-6 py-16 lg:px-8">
            {/* Optional background image / paper texture placeholder */}
            <div
                className="absolute inset-0 bg-cover bg-center opacity-10"
                style={{
                    backgroundImage: "url('/assets/schools/problem-texture.png')",
                }}
            />

            <div className="relative mx-auto max-w-5xl">
                <div className="mb-8 text-center">
                    <div className="mx-auto mb-4 inline-flex items-center gap-2 border-[3px] border-black bg-[#ff3366] px-4 py-2 text-sm font-black uppercase text-white shadow-[4px_4px_0_#000]">
                        <AlertTriangle size={18} strokeWidth={3} />
                        The Problem
                    </div>

                    <h2 className="text-4xl font-black uppercase leading-none md:text-5xl">
                        The Problem Schools Are Facing
                    </h2>
                </div>

                <div className="grid gap-7 md:grid-cols-[1fr_1.1fr] md:items-start">
                    <section className="rounded-[26px] border-[5px] border-black bg-white p-6 shadow-[8px_8px_0_#000]">
                        <p className="text-xl font-bold leading-9 md:text-2xl">
                            Bullying doesn’t just happen in hallways anymore — it lives
                            in group chats, social media, and silence.
                        </p>

                        <div className="mt-6 rounded-[18px] border-[3px] border-black bg-[#fff2cf] p-4">
                            <p className="text-sm font-bold leading-7 md:text-base">
                                Traditional approaches aren’t enough. Assemblies are
                                forgotten. Rules don’t change behavior.
                            </p>
                        </div>
                    </section>

                    <ChecklistStrip
                        icon={AlertTriangle}
                        title="Students Often..."
                        items={studentProblems}
                        color="bg-[#ffbc00]"
                    />
                </div>

                <div className="mx-auto mt-8 max-w-3xl rotate-[-1deg] rounded-[20px] border-[4px] border-black bg-[#16bdf4] p-5 text-center shadow-[7px_7px_0_#000]">
                    <p className="text-2xl font-black uppercase leading-tight text-white drop-shadow-[2px_2px_0_#000]">
                        Students need practice — not just policies.
                    </p>
                </div>
            </div>
        </section>
    );
}